/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  requestPhoneVerificationCode({ inboxId, codeMethod = 'SMS' }) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/authorization/request_phone_verification_code`,
      {
        inbox_id: inboxId,
        code_method: codeMethod,
      }
    );
  }

  verifyPhoneRegistration({ inboxId, verificationCode, verificationPin }) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/authorization/verify_phone_registration`,
      {
        inbox_id: inboxId,
        verification_code: verificationCode,
        verification_pin: verificationPin,
      }
    );
  }
}

export default new WhatsappChannel();
